import React from "react";
import sIcon1 from "../../images/icons/icon_clock.svg";
import sIcon2 from "../../images/icons/icon_dart_board_2.svg";
import sIcon3 from "../../images/icons/icon_target.svg";

const Policy = [
  {
    title: "Our Values",
    subTitle:
      "We strive for excellence in everything we do, our customers are at the heart of our business and we prioritize their needs to provide exceptional services.",
    icon: sIcon1,
  },
  {
    title: "Our Mission",
    subTitle:
      "To empower individuals and businesses with innovative IT solutions and exceptional service, fostering growth and success in the digital age.",
    icon: sIcon2,
  },
  {
    title: "Our Vision",
    subTitle:
      "Our vision is to provide exceptional IT products, accessories and installation services",
    icon: sIcon3,
  },
];

const PolicySection = (props) => {
  return (
    <section className="policy_section bg-light">
      <div className="container">
        <div className="row">
          {Policy.map((policy, pitem) => (
            <div className="col-lg-4" key={pitem}>
              <div className="iconbox_block">
                <div className="iconbox_icon">
                  <img src={policy.icon} alt="Dollar SVG Icon" />
                </div>
                <div className="iconbox_content">
                  <h3 className="iconbox_title">{policy.title}</h3>
                  <p className="mb-0">{policy.subTitle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PolicySection;
